module.exports = __webpack_public_path__ + "static/media/magnetboard.a2d559fc.png";